import {enableProdMode, ViewEncapsulation} from "@angular/core";
import {platformBrowserDynamic}            from "@angular/platform-browser-dynamic";
import {Config}                            from "@synisys/idm-ui-shell/app/config";
import {AppModule}                         from "./app.module";

import "zone.js/dist/zone";
import {SpeedDetectorService} from "../../../core-setup/router/speed-detector.service"; // import zone.js at the very last, in order not to have it overwritten

import {Yggdrasil} from "@synisys/yggdrasil";

if (process.env.NODE_ENV === "production") {
  // Production
  enableProdMode();
} else {
  // Development and test
  Error["stackTraceLimit"] = Infinity;
  require("zone.js/dist/long-stack-trace-zone");
}

// detect speed of the user's internet speed
new SpeedDetectorService().detectSpeed();



Yggdrasil.bootstrap({
  scriptUrl: `${window["deployContext"]}node_modules/@synisys/tir/worker.js`.replace(/(?<!:)\/+/gm, "/"),
  hostUrl: `${window.location.origin}`,
  deployContext: `${window["deployContext"]}`,
  routeNavigator: {
    navigateTo: (url: string) => {
      window.history.pushState({}, "", url);
    }
  },
  rootPages: []
}).then(() => {
    console.log("Yggdrasil started");
    window.dispatchEvent(
      new CustomEvent("yggdrasil-started", {
        detail: {
          yggdrasil: window.yggdrasil
        }
      })
    );
  }
).then(() => {
  platformBrowserDynamic([
    {provide: Config.coreConfigPathToken, useValue: "./app/config"},
    {provide: "imagesPath", useValue: "images"},
    {provide: "configPath", useValue: "./app/config"}
  ]).bootstrapModule(AppModule, [{defaultEncapsulation: ViewEncapsulation.None}]);
});

